export const getImageVideoUrl = (name: string): string => {
  const url = localStorage.getItem("HVS_API_URL");

  // TODO this can be problematic if the token meanwhile expires
  return `${url}attachments/download/${name}?tk=${window.KEYCLOAK?.token}`;
};
